import * as Yup from "yup";
import getDayjs from "../../../../context/DateInstance"


const initValuesTicket = {
    support_type: "",
    support_subtype: "",
    support_subtype_1: "",
    comment: "",
    eventDate: getDayjs(),
    departmentShortName: "",
    department: ""
}

const validationSchemaTicket = Yup.object().shape({
    departmentShortName: Yup.string().required('Por favor selecciona el departamento.'),
    support_type: Yup.number().required('Por favor selecciona el tipo de soporte.'),
    support_subtype: Yup.number().required("Por favor especifica el inconveniente."),
    support_subtype_1: Yup.number().required("Por favor especifica el inconveniente."),
    eventDate: Yup.date(),
    comment: Yup.string().required('Por favor describa la solicitud.')
})

export { initValuesTicket, validationSchemaTicket }

